import bus from '@/utils/eventBus'

export default function () {
  bus.$on('on-uploaded-book-occurrence-image', values => {
    this.onUploadedOccurrenceImg(values.response)
  })
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/form/resources/mounted.js